export default function (input) {
    const result = {};

    input.forEach((hit) => {
        const key = `${hit.year}-${hit.monthName[0]}`;

        if (!result[key]) {
            result[key] = { month: hit.monthName[0], year: hit.year, entries: [] };
        }

        result[key].entries.push(hit);
    });

    const sortedResult = Object.values(result).sort((a, b) => {
        if (a.year === b.year) {
            return new Date(`${a.month} 1, 2000`) - new Date(`${b.month} 1, 2000}`);
        }
        return a.year - b.year;
    });

    return sortedResult;
}
